<div id="main" perfectScrollbar (psScrollY)="onPsScrollY($event)" class="h-100">
	<header class="header" [class.over]="showInfoContent">
		<mat-toolbar class="top-toolbar" [class.mat-elevation-z2]="settings.fixedHeader">
			<div fxLayout="row" fxLayoutAlign="space-between center" fxFlex>
				<div fxLayout="row" [attr.fxLayoutAlign]="isBusy ? 'center center' : 'start center'">
					<a routerLink="/" title="Home" fxLayout="row" [attr.fxLayoutAlign]="isBusy ? 'center center' : 'start center'" class="logo" ngClass.xs="mobile" (click)="closeSubMenus()">
						<app-logo-small *ngIf="!isBusy" @fadeIn fxLayoutAlign="center center"></app-logo-small>
						<app-busy-indicator size="small" [isBusy]="isBusy" fxLayoutAlign="center center"></app-busy-indicator>
						<span class="mx-2 application-name" [textContent]="applicationName"></span>
					</a>
				</div>
				<div fxLayout="row" fxLayoutAlign="start center" class="w-100">
					<button *ngIf="isVerticalMenu" title="Toggle left navigation bar" mat-icon-button (click)="toggleSidenav()">
                        <mat-icon>menu</mat-icon>
                    </button>
					<app-favorites fxShow="false" fxShow.gt-sm [menuItems]="favoriteMenus"></app-favorites>
				</div>
				<div fxLayout="row" fxLayoutAlign="end center">
					<!-- <div fxLayout="row" fxLayoutAlign="start center" fxShow="false" fxShow.gt-xs class="search-bar">
                        <form method="get">
                            <input type="text" placeholder="Type to search..." class="mat-elevation-z3" [class.show]="toggleSearchBar">
                            <button mat-icon-button (click)="toggleSearchBar = !toggleSearchBar" type="button">
                                <mat-icon>search</mat-icon>
                            </button>
                        </form>
                    </div>
                    <app-messages fxShow="false" fxShow.gt-xs></app-messages> -->
					<app-user-menu fxLayoutAlign="center" [profilePic]="menuService.userProfile.pictureUrl"></app-user-menu>
				</div>
			</div>
		</mat-toolbar>
		<mat-toolbar *ngIf="!isVerticalMenu " class="horizontal-menu px-0 mat-elevation-z2">
			<div fxLayout="row" fxLayoutAlign="center center" class="w-100">
				<app-horizontal-menu [menuParentId]="defaultHomeMenuId" [class.w-100]="(settings.menuType!='mini')" [menuItems]="menuService.menus"></app-horizontal-menu>
			</div>
		</mat-toolbar>
	</header>

	<mat-drawer-container class="page-wrapper" [class.horizontal-menu-shown]="!isVerticalMenu" (backdropClick)="closeSubMenus()">
		<!-- <header class="header" id="drawerContent">
            <mat-toolbar *ngIf="!isVerticalMenu " class="horizontal-menu px-0">
                <div fxLayout="row" fxLayoutAlign="center center" class="w-100">
                    <app-horizontal-menu [menuParentId]="defaultHomeMenuId" [class.w-100]="(settings.menuType!='mini')" [menuItems]="menuService.menus"></app-horizontal-menu>
                </div>
            </mat-toolbar>
        </header>
        <router-outlet></router-outlet> -->
		<mat-drawer-content id="drawerContent">
			<router-outlet></router-outlet>
		</mat-drawer-content>
		<mat-drawer #sidenav *ngIf="isVerticalMenu" [mode]="(settings.sidenavIsPinned) ? 'side' : 'over'" (openedStart)="onOpenedStart($event)" (closedStart)="onClosedStart()"
						class="sidenav mat-elevation-z6" autoFocus="false">
			<mat-toolbar *ngIf="settings.fixedSidenav" class="top-toolbar">
				<a routerLink="/" fxLayout="row" [attr.fxLayoutAlign]="isBusy ? 'center center' : 'start center'" class="logo">
					<app-logo-small title="Trackinator Logo"></app-logo-small>
					<app-busy-indicator size="small" [isBusy]="isBusy"></app-busy-indicator>
					<span class="mx-2" [textContent]="applicationName"></span>
				</a>
			</mat-toolbar>
			<app-sidenav [profilePic]="menuService.userProfile.pictureUrl" [menuItems]="menuService.menus"></app-sidenav>
		</mat-drawer>

	</mat-drawer-container>

	<div #backToTop fxLayout="row" fxLayoutAlign="center center" class="back-to-top" (click)="scrollToTop()">
		<mat-icon>arrow_upward</mat-icon>
	</div>

	<mat-toolbar color="primary" class="footer" [class.full-width]="!sidenavIsOpened">
		<div *ngIf="!isLoggedIn">
			<a mat-raised-button color="accent" @fadeIn [href]="appUrl.pabblyMonthlyCheckout">
				<mat-icon class="mx-2 animate__animated animate__bounce animate__delay-5s animate__rubberBand animate__repeat-3">shopping_cart</mat-icon>
				<span fxHide fxShow.gt-sm>Subscribe Now!</span>
			</a>
		</div>
		<span class="fill-space"></span>
		<span fxShow fxShow.gt-xs class="app-version">v{{appVersion}}</span>
	</mat-toolbar>
	<!-- https://payments.pabbly.com/subscribe/5f42e4c335a5d50a2045960c/trackinator-gold?customer_id=5f4e1ae2ca1c5e149c11a05d -->
	<!-- https://payments.pabbly.com/subscribe/5f42e4c335a5d50a2045960c/customer_id=5f4e1ae2ca1c5e149c11a05d -->
</div>